import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DIALOG_BUTTONS } from '../../constants';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false,
})
export class DialogComponent {
  data = inject<{
    title: string;
    description: string;
    sharedButtonClass: string;
    sharedButtonText: string;
    showCancelButton?: boolean;
  }>(MAT_DIALOG_DATA);
  translate = inject(TranslateService);

  readonly buttons = DIALOG_BUTTONS;

  constructor() {
    const translate = this.translate;

    this.data.showCancelButton = this.data.showCancelButton ?? true;
    translate.addLangs(['en']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en/) ? browserLang : 'en');
  }
}
